exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2GNcpU5w5AyDKmSe4yx7B5{height:90vh;width:90vw;overflow-y:hidden}._1-r8qc48IEYPjnMtuhrhGH{height:100%}._3TtCiqZWoDlJ_hnYoXxY2{display:-webkit-box;display:-ms-flexbox;display:flex;min-width:100%;height:calc(100% - 40px)}html[dir] ._3TtCiqZWoDlJ_hnYoXxY2{padding:0}._1dCcE8z5KwadN9dNl3_vXg{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}", ""]);
// Exports
exports.locals = {
	"modalContainer": "_2GNcpU5w5AyDKmSe4yx7B5",
	"filePickerContent": "_1-r8qc48IEYPjnMtuhrhGH",
	"content": "_3TtCiqZWoDlJ_hnYoXxY2",
	"filePickerPane": "_1dCcE8z5KwadN9dNl3_vXg"
};